
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function SystemicLupusErythematosus(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Systemic lupus erythematosus"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Systemic lupus erythematosus (SLE), is the
                                    most <b>common type of lupus</b>. SLE is an
                                    autoimmune disease in which the immune
                                    system attacks its own tissues, causing
                                    widespread inflammation and tissue damage in
                                    the affected organs. It can affect the joints, skin,
                                    brain, lungs, kidneys, and blood vessels.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Systemic-lupus-erythematosus/1.jpg")} alt="Systemic-lupus-erythematosus" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Pain areas:</b>
                                            <br />
                                            in the muscles
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Pain types:</b>
                                            <br />
                                            can be sharp in the chest
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Pain circumstances:</b>
                                            <br />
                                            can occur while breathing
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Whole body:</b>
                                            <br />
                                            anaemia, fatigue, fever, or malaise
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Hair:</b>
                                            <br />
                                            hair loss or loss of scalp hair
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Skin:</b>
                                            <br />
                                            red rashes or scaly rashes
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Hair:</b>
                                            <br />
                                            dryness or ulcers
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common: </b>
                                            <br />
                                            anxiety, blood in urine, clinical depression, face rash, flare, headache, joint stiffness,
                                            raynaud's, sensitivity to light, swelling, water retention, or weight loss
                                        </p>
                                    </li>
                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Lupus">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default SystemicLupusErythematosus;